const mFormMessages = {
		error: "Error",
		invalid: "Invalid input",
		outRange: "Value is out of range"
	};

export default {
	data() {
		return {			
			mFormRules: {
				required(v) {
					if(!v) {
						return "Compilare questo campo";
					}

					return true;
				},

				integer(v) {
					const defaultLimits = [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER];

					// Check whether the value is a number
					if(isNaN(v)) {
						return mFormMessages.invalid;
					}

					// Check whether the extents are properly defined,
					// if they have been overridden.
					let limits = undefined;
					if(limits && limits.length < 2) {
						throw new Error("Limit for the number input is not properly defined")
					} else {
						limits = defaultLimits;
					}

					// Check the value against the limit defined
					if(v < limits[0] || v > limits[1]) {
						return mFormMessages.outRange;
					}

					return true;
				}
			}
		}
	}
}